import styled from "styled-components";

export const ContentPopup = styled.div`
  display: grid;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  opacity: 0;
  animation: dropdown 1s ease-out forwards;

  @media (max-width: 450px) {
    z-index: 3000;
    top: 20px;
    left: 10px;
    right: 10px;
    bottom: initial;
  }

  @keyframes dropdown {
    from {
      opacity: 0;
      transform: translateX(100px);
    }
    to {
      opacity: 1;
      transform: translateX(0px);
    }
  }
`;
